<template>
  <div>
    <h1 v-if="project.completion > 0" class="my-2">
      {{ $t('fields.completion') }}
    </h1>
    <v-sheet
      v-if="project.completion > 0"
      width="100%"
      height="20px"
      color="black"
      class="text-center"
    >
      <v-sheet
        :width="`${project.completion}%`"
        height="20px"
        :color="getProjectColor(project.completion)"
        dark
      >
        {{ project.completion }}%
      </v-sheet>
    </v-sheet>
    <v-tabs
      v-if="project.before"
      v-model="projectTab"
      background-color="transparent"
      color="primary"
      class="my-2"
      grow
    >
      <v-tab>
        {{ $t('fields.before') }}
      </v-tab>
      <v-tab :disabled="!project.after">
        {{ $t('fields.after') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="projectTab">
      <v-tab-item>
        <TextWidget :text="project.before"></TextWidget>
      </v-tab-item>
      <v-tab-item>
        <TextWidget :text="project.after"></TextWidget>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import TextWidget from '~/components/widget/TextWidget'
export default {
  name: 'ProjectView',
  components: { TextWidget },
  props: {
    project: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      projectTab: null,
    }
  },
  methods: {
    getProjectColor(completion) {
      if (completion > 99) return 'success lighten-2'
      if (completion > 70) return 'success'
      if (completion > 40) return 'warning'
      return 'error'
    },
  },
}
</script>
